import type { AppRouteRecordRaw } from "shared/types";
import {
  LAYOUTS,
  MANAGER_ROLES,
  MEETING_OVERVIEW_ROLES,
  MODULE_SETTINGS,
} from "shared/constants";
import { STUDENT_MEETING_ROUTE_NAMES } from "meetings/student-meeting/routes/routeNames";

export const studentMeetingManageFragment: AppRouteRecordRaw[] = [
  {
    path: "student-meeting/:id",
    name: STUDENT_MEETING_ROUTE_NAMES.MANAGE,
    component: () =>
      import("meetings/student-meeting/pages/teacher/StudentMeetingManagePage.vue"),
    meta: {
      title: "Leerlingbespreking beheren",
      // Read-only for a teamleader; the page hides its manage actions for them.
      roleRequired: MEETING_OVERVIEW_ROLES,
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      hideTitle: true,
      hideSubmenu: true,
    },
  },
  {
    path: "student-meeting/edit/:id",
    name: STUDENT_MEETING_ROUTE_NAMES.EDIT,
    component: () =>
      import("meetings/student-meeting/pages/teacher/StudentMeetingEditPage.vue"),
    meta: {
      title: "Leerlingbespreking bewerken",
      roleRequired: MANAGER_ROLES,
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      hideTitle: true,
      hideSubmenu: true,
    },
  },
  {
    path: "add-student-meeting",
    component: () => import("views/EmptyView.vue"),
    meta: {
      title: "Leerlingbespreking toevoegen",
      roleRequired: MANAGER_ROLES,
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      hideTitle: true,
    },
    children: [
      {
        path: "",
        name: STUDENT_MEETING_ROUTE_NAMES.CREATE,
        component: () =>
          import("meetings/student-meeting/pages/teacher/StudentMeetingCreatePage.vue"),
        meta: {
          title: "Leerlingbespreking toevoegen",
          roleRequired: MANAGER_ROLES,
          settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
          hideSubmenu: true,
        },
      },
    ],
  },
];
